import type { CodeProfile } from "./types";

/** ABD: IBC 2021 §1807.2 (devrilme/kayma GK 1,5), AASHTO LRFD §11.6 (e ≤ B/3 depremde, kh = 0,5·kmax), taşıma gücü GK 3 (ASD). */
export const US_PROFILE: CodeProfile = {
  id: "us",
  label: "ABD ASD",
  verification: "asd",
  references: [
    "IBC 2021 — International Building Code, §1807.2 Retaining Walls (devrilme ve kayma için GK ≥ 1,5).",
    "AASHTO LRFD Bridge Design Specifications (9th ed.), §11.6 Abutments and Conventional Retaining Walls; §11.6.5 Seismic Design (kh = 0,5·kmax).",
    "ASCE/SEI 7-22 — §11 Seismic Design Criteria (PGA, FPGA).",
    "NAVFAC DM-7.02 — Foundations and Earth Structures.",
    "Das, B. M., Principles of Foundation Engineering — Chapter 13 Retaining Walls.",
  ],
};
